<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

let newData = {
  xAxis: ['小麦', '玉米', '大豆'],
  yAxis: [
    {
      name: '2021',
      value: [84.61, 42.27, 3]
    },
    {
      name: '2022',
      value: [91.53, 47.59, 2.87]
    },
    {
      name: '2023',
      value: [82.81, 58.54, 1.98],
    },
  ],
}
let legendData = [];
let seriesData = [];
let colorArr = ['#44C558','#0BC2FB', '#26306D',  '#2F8FFF'];
legendData = newData.yAxis.map((item) => item.name);
seriesData = newData.yAxis.map((item1, index1) => {
  return {
    name: item1.name,
    type: 'bar',
    barWidth: 20,
    silent: true,
    itemStyle: {
      normal: {
        color: colorArr[index1],
        barBorderRadius: [30, 30, 0, 0],
      },
    },
    data: item1.value,
  }
})




// 创建ECharts配置对象
const option = {
  // backgroundColor: '#0E1327',
  grid: {
    containLabel: true,
    bottom: '5%',
    top: '20%',
    left: '5%',
    right: '5%',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    formatter: (params) => {
      let arr = [...params];
      let str = '';
      arr.forEach((item, index) => {
        str += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' +
          colorArr[index] +
          ';"></span>' + item.seriesName + ' : ' + item.data + '万吨<br />';
      });
      str = arr[0].name + '<br />' + str;
      return str;
    },
  },
  legend: {
    orient: 'horizontal',
    top: '10%',
    right: '2%',
    data: legendData,
    itemWidth: 15,
    itemHeight: 15,
    itemGap: 40,
    icon: "rect",
    textStyle: {
      fontSize: 18,
      color: '#fff',
      padding: [5, 0, 0, 2],
      rich: {
        a: {
          verticalAlign: 'middle',
        },
      },
    },

  },
  xAxis: {
    triggerEvent: true,
    data: ['小麦总产量', '玉米总产量', '大豆总产量'],
    axisLabel: {
      show: true,
      fontSize: 14,
      color: '#fff',
      align: 'center',
      verticalAlign: 'top',
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: true,
      lineStyle: {
        show: true,
        color: '#0B3561',
        width: 2,
      },
    },
  },
  yAxis: [
    {
      name: '单位(万吨)',
      nameTextStyle: {
        color: "#fff",
        fontSize: 16,

      },
      axisLabel: {
        interval: 0,
        show: true,
        fontSize: 18,
        color: '#fff',
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          type: 'solid',
          color: '#0B3561',
        },
      },
    },
  ],
  series: seriesData,

};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);


    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
